module.exports = __webpack_public_path__ + "static/media/student-setting-password02.8c4c1a34.png";